import { UseFormReturn } from 'react-hook-form';

import { FormField, FormItem, FormMessage } from '@@/ui/primitives';
import { Field } from '../../../../schemas/entity';
import { CreateItemPayload } from '../../../../schemas/item';
import { BooleanInput } from '../../../shared/field-inputs';

interface BooleanFieldRendererProps {
  fieldKey: string;
  field: Field;
  form: UseFormReturn<CreateItemPayload['attributes']>;
  label: string;
  disabled?: boolean;
}

export function BooleanFieldRenderer({ fieldKey, field, form, label, disabled = false }: BooleanFieldRendererProps) {
  const definition = field.definition;

  if (definition.type !== 'boolean') {
    return null;
  }

  return (
    <FormField
      control={form.control}
      name={fieldKey}
      render={({ field: formField }) => (
        <FormItem>
          <BooleanInput
            value={formField.value ?? false}
            onChange={formField.onChange}
            label={label}
            disabled={disabled}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
